// Price text for the wizard live card: digits only, zh-TW thousands separators, e.g. "NT$ 12,000/月".
const PRICE_FORMAT = new Intl.NumberFormat("zh-TW")

export function formatLivePrice(raw, prefix = "NT$ ", suffix = "") {
  const digits = String(raw ?? "").replace(/[^\d]/g, "")
  if (!digits) return ""
  return `${prefix}${PRICE_FORMAT.format(Number(digits))}${suffix}`
}
